import React, { lazy, useState, useEffect } from 'react';
import { Box, Button, Typography, useMediaQuery } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useCompanyData } from '../../shared/contexts/DataContext';
import CustomMetaData from 'src/hooks/CustomMetaData';
import { useNavigate, useParams } from 'react-router-dom';
import { aboutImage, bannerImage } from '../../shared/logic/imagesFns';
import useRTL from 'src/hooks/useRTL';
import * as Components from '../../shared/sections';
import '../../shared/styles.css'

const CustomPage = (props) => {
    const { data } = useCompanyData();
    const navigate = useNavigate();
    const { pageId } = useParams();
    const { t, companyDomain, homepageSections, pageList, companyData, themeDesign } = data;
    const { id } = companyData || {};

    const handleExploreServices = () => {
      navigate(companyDomain ? '/temp/services' : `/${id}/temp/services`);
    };

    const handleExploreCategories = () => {
      navigate(companyDomain ? '/temp/categories' : `/${id}/temp/categories`);
    };

    const [, , fontFamily] = useRTL('',"Playfair Display, serif");

    const maxServiceShow =  pageList && Object.keys(pageList)?.length && pageId ?  pageList[pageId]?.maxDisplayItems ? pageList[pageId]?.maxDisplayItems : 4 : 4;

    useEffect(()=> {
      window.scrollTo(0, 0);
    },[]);

    const ComponentLists = {
      ...Components,
    };

    const staticProps = {
      headerTitle: data?.companyData?.name,
      height:"500px",
      aboutName: data.companyData?.name,
      aboutImage: pageList && Object.keys(pageList) && pageId && pageList[pageId]?.aboutImage || aboutImage(data),
      aboutTitle: pageList && Object.keys(pageList) && pageId ? pageList[pageId]?.aboutTitle : '',
      aboutDescription: pageList && Object.keys(pageList) && pageId && pageList[pageId]?.description || companyData?.description,
      arAboutTitle: pageList && Object.keys(pageList) && pageId ? pageList[pageId]?.arAboutTitle : '',
      arAboutDescription: pageList && Object.keys(pageList) && pageId && pageList[pageId]?.arAboutDescription || companyData?.description,
      aboutBackgroundColor: pageList && Object.keys(pageList) && pageId && pageList[pageId]?.aboutBackgroundColor || '#ffffff',
      aboutBackgroundImage: pageList && Object.keys(pageList) && pageId && pageList[pageId]?.aboutBackgroundImage || '',
      aboutBackgroundStyle: pageList && Object.keys(pageList) && pageId && pageList[pageId]?.backgroundStyle || '',
      aboutSectionStyle: {
        titleFormat: pageList && Object.keys(pageList)?.length && pageId ? pageList[pageId]?.titleFormat || '' : '',
        titleFontSize: pageList && Object.keys(pageList)?.length && pageId ? pageList[pageId]?.titleFontSize || '' : '',
        subTitleFontSize: pageList && Object.keys(pageList)?.length && pageId ? pageList[pageId]?.subTitleFontSize || '' : '',
        descriptionFontSize: pageList && Object.keys(pageList)?.length && pageId ? pageList[pageId]?.descriptionFontSize || '' : '',
        titleFontColor: pageList && Object.keys(pageList)?.length && pageId ? pageList[pageId]?.titleFontColor || '' : '',
        subTitleFontColor: pageList && Object.keys(pageList)?.length && pageId ? pageList[pageId]?.subTitleFontColor || '' : '',
        textFontColor: pageList && Object.keys(pageList)?.length && pageId ? pageList[pageId]?.textFontColor || '' : '',
        paddingTop: pageList && Object.keys(pageList)?.length && pageId ? pageList[pageId]?.paddingTop || '' : '',
        paddingBottom: pageList && Object.keys(pageList)?.length && pageId ? pageList[pageId]?.paddingBottom || '' : '',
      },
      productDisplayHorizontal: pageList && Object.keys(pageList) && pageId ? pageList[pageId]?.productDisplayHorizontal : false,
      displayDescription: pageList && Object.keys(pageList) && pageId ? pageList[pageId]?.displayProductDesc !== undefined ? pageList[pageId]?.displayProductDesc : true : true,
      services: data.products || [],
      categories: data.categories || [],
      courses: data.courses || [],
      teamMembers: data.teams || [],
      maxServiceShow,
      handleExploreServices,
      handleExploreCategories,
      fontFamily,
      t,
      data,
      seoTitle: pageList && Object.keys(pageList) && pageId ? pageList[pageId]?.seoTitle : companyData ? `${companyData.name}` : '',
      seoDescription: pageList && Object.keys(pageList) && pageId ? pageList[pageId]?.seoDescription : companyData ? `${companyData.description}` : '',
    };

    const DynamicHeader = pageList && pageId ? ComponentLists[`${pageList[pageId]?.headerType}${themeDesign}`] : '';
  return (
    <>
        <CustomMetaData
          {...{
            title: staticProps?.seoTitle,
            image:  companyData && companyData.avatar,
            description: staticProps?.seoDescription
          }}
        />

        {/* dynamic header */}
        {pageList && pageId && pageList[pageId]?.headerType !== undefined && ['HomeHeader','SimpleHeader']?.includes(pageList[pageId]?.headerType)  ?
          <DynamicHeader {...staticProps} title={pageList[pageId]?.pageTitle} />
        : null
        }

        <div style={pageList && pageId && (pageList[pageId]?.headerType === undefined  || pageList[pageId]?.headerType === 'none' || pageList[pageId]?.headerType == '') ? {marginTop:'110px'} : {}}>
        {pageList && Object.keys(pageList)?.length && pageId && pageList[pageId]?.contentList?.length ?
            React.Children.toArray(pageList[pageId]?.contentList.map(v => {
              const _compName = v?.ComponentName;
              const componentName = _compName === "Content" ? `${_compName}${v?.design || 1}` : ['Services','Courses']?.includes(_compName) && v?.design ? `${_compName}${v?.design || 1}` : _compName;
              const DynamicComponent = v.visible ? ['About', 'Services', 'Teams', 'Courses']?.includes(componentName) ? ComponentLists[`${componentName}${themeDesign}`] : ComponentLists[componentName] : ComponentLists['EmptyComponent'];
            // const DynamicComponent = v.visible ? ComponentLists[componentName] : ComponentLists['EmptyComponent'];
            return <DynamicComponent {...staticProps} contentData={v.content || {}} productType={v.value} />
            }))
        : 
        null
        }
        </div>
    </>
  );
};

export default CustomPage;
